import { InjectionToken } from '@angular/core';
import { IPixabayImages } from '@boxx/boxx-images/lib/contracts/IImages';
import { Observable } from 'rxjs';
import { CategoryModel } from '../models/Category.model';
import { EcwidModel } from '../models/Ecwid.model';
import { EcwidImageModel } from '../models/EcwidImage.model';
import { ImageModel } from '../models/Image.model';
import { OrderModel } from '../models/Order.model';
import { IProductImages, IProductImageUpload, ProductModel } from '../models/Product.model';
import { IUpdateProfileStorePayload, StatesModelProps, StoreProfileModel } from '../models/Store.model';
import { VariationModel } from '../models/Variation.model';
import {
    ICategoryImageUploadApiModel,
    ICreateVariationPayload,
    IEcwidImageUpload,
    IProductApiModel,
    IProfileApiModel,
    IUpdateStatusOrderPayload,
    IUpsertCategoryPayload,
    IUpsertProductPayload
} from '../repositories/IStore.api';

export interface IStoreService {
    // --------------------- CATEGORIES: -------------------------
    loadCategories(): Observable<CategoryModel[]>;
    loadCategoryById(id: number): Observable<CategoryModel>;
    getSingleCategory(id: number): Observable<ICategoryImageUploadApiModel>;
    createCategory(payload: IUpsertCategoryPayload): Observable<CategoryModel>;
    //createCategory(payload: IUpsertCategoryPayload): Promise<any>;
    updateCategory(payload: IUpsertCategoryPayload): Observable<CategoryModel>;
    deleteCategory(payload: any): Observable<boolean>;
    uploadImageCategory(id: number, file: string): Observable<EcwidImageModel>;
    deleteImageCategory(payload: any): Observable<boolean>;
    
    // --------------------- ORDERS: -------------------------
    loadOrders(): Observable<OrderModel[]>;
    loadOrderById(id: string): Observable<OrderModel>;
    updateOrder(payload: IUpdateStatusOrderPayload): Observable<OrderModel>;

    // --------------------- PRODUCTS: -------------------------
    loadProducts(): Observable<ProductModel[]>;
    loadProductById(id: number): Observable<ProductModel>;
    createProduct(payload: IUpsertProductPayload): Observable<ProductModel>;
    updateProduct(payload: IUpsertProductPayload): Observable<ProductModel>;
    deleteProduct(id: number): Observable<boolean>;
    getSingleProduct(id: number): Observable<IProductApiModel>;
    uploadImageProduct(payload: IProductImageUpload): Promise<any>;
    deleteImageProduct(payload: any): Observable<boolean>;

    // ---------------- PRODUCT VARIATIONS: ---------------------
    loadProductsVariations(): Observable<VariationModel[]>;
    loadProductVariationById(id: number): Observable<VariationModel>;
    createProductVariation(payload: ICreateVariationPayload): Observable<VariationModel>;
    deleteProductVariation(id: number): Observable<boolean>;

    // --------------------- IMAGES: -------------------------
    loadSiteImages(): Observable<ImageModel[]>;
    loadSiteImageById(id: number): Observable<ImageModel>;
    createSiteImage(payload: number): Observable<ImageModel>;
    deleteSiteImage(id: number): Observable<boolean>;
    searchImages(imageFilter: any): Observable<IPixabayImages>;

    // --------------------- ECWID: -------------------------
    getLinkValidation(): Observable<EcwidModel>;
    getToken(bId: number, businessId: number): Observable<EcwidModel>;
    getProfile(): Observable<StoreProfileModel>;
    updateProfile(payload: IUpdateProfileStorePayload): Observable<IProfileApiModel>;
    uploadImageProfile(file: string): Observable<EcwidImageModel>;
    deleteImageProfile(payload: any): Observable<boolean>;

    // --------------------- COUPONS: -------------------------
    loadCoupons(): Observable<any[]>;
    createCoupon(payload: any): Observable<any>;
    updateCoupon(payload: any): Observable<any>;
    deleteCoupon(id: number): Observable<boolean>;
    getSingleCoupon(id: number): Observable<any>;
    
}

export const STORE_SERVICE = new InjectionToken<IStoreService>('StoreService');
